export default __webpack_public_path__ + "media/images/features/local_delivery/episode3/admin-3085c9bcb88d7285ade75f42ff123217.jpg";